import React from 'react';
import { func, object } from 'prop-types';
import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';

/**
 * These styles were copied over from Material UI's Switch documentation.
 * Because this application's styles are loaded in the DOM *before* Material
 * UI's, style overrides require a lot of `!important`s. Because the styling
 * of this component is a bit non-trivial, `makeStyles` is used here to
 * ensure that the rules are applied with the right priority so as to avoid
 * the need to `!important` everything.
 *
 * See also:
 *
 * *  https://material-ui.com/styles/basics/
 * *  https://material-ui.com/api/switch/
 */
const useStyles = makeStyles({
    root: {
        width:   42,
        height:  26,
        padding: 0,
        margin:  0,
    },
    switchBase: {
        padding:     1,
        '&$checked': {
            transform:    'translateX(16px)',
            color:        '#fafafa',
            '& + $track': {
                backgroundColor: '#52d869',
                opacity:         1,
                border:          'none',
            },
        },
        '&$focusVisible $thumb': {
            color:  '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width:  24,
        height: 24,
    },
    track: {
        borderRadius:    26 / 2,
        border:          '1px solid #bdbdbd',
        backgroundColor: '#fafafa',
        opacity:         1,
    },
    checked:      {},
    focusVisible: {}
});

const SwitchBase = ({ inputProps, onBlur, onChange, ...props }) => {
    const classes = useStyles();
    /**
     * Normalize the event target's value property.
     * If there is no `value` attribute, then map the event target's value to
     * that of the `checked` state. If there _is_ a `value` attribute, then only
     * include that in the event if the checked state is TRUE.
     */
    function handleChange(event) {
        const { checked, value } = event.target;
        let newValue;
        if (value === '') {
            newValue = checked;
        } else {
            newValue = checked ? value : undefined;
        }
        event.target.value = newValue;
        onChange(event);
    }

    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            classes={{
                root:       classes.root,
                switchBase: classes.switchBase,
                thumb:      classes.thumb,
                track:      classes.track,
                checked:    classes.checked
            }}
            disableRipple
            inputProps={{
                onBlur,
                ...inputProps
            }}
            onChange={handleChange}
            {...props}
        />
    );
};

SwitchBase.propTypes = {
    classes:    {},
    inputProps: {},
    onBlur:     () => {},
    onChange:   () => {}
};

SwitchBase.propTypes = {
    classes:    object,
    inputProps: object,
    onBlur:     func,
    onChange:   func
};

export default SwitchBase;
